import { EventEmitter, Output } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';

@Component({
  selector: 'app-adddevices',
  templateUrl: './adddevices.component.html',
  styleUrls: ['./adddevices.component.css']
})
export class AdddevicesComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;


  //Edit Get Values
  devicesColl: any = [];
  devicesid: number = 0

  devicesform = new FormGroup({
    devicesid: new FormControl(0),
    devicestype: new FormControl('', Validators.required),
    devicescode: new FormControl(null, Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Devices";


  @Input() devicestype: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.devicesid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.devicesform.reset();
      this.fnInitializeDevices();

      if (this.devicesid > 0) {
        this.fngetDevices();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.devicesid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeDevices() {
    this.devicesform.setValue({

      devicesid: 0,
      devicestype: '',
      devicescode: null,
      inactive: false,
    })
  }

  //Get 
  fngetDevices() {

    var data = {
      'devicesid': this.devicesid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getDevices(data)
      .subscribe(
        (res) => {
          this.devicesColl = res.json().result;
          var editdata = this.devicesColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if(this.saveloading){
        return
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.devicesform.valid) {
        this.saveloading= true;
        //Check
        var data = {
          'devicesid': this.devicesid,
          'devicestype': this.devicesform.get('devicestype').value,
          'devicescode': this.devicesform.get('devicescode').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.devicesform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        if (this.devicesform.get('devicesid').value > 0) {
          //Update Department
          this.fnSetDevices(data);
        }
      }
    } catch (ex) {
      this.saveloading= false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Set
  fnSetDevices(data) {

    this.appService.fnSetDevices(data).subscribe(
      (res) => {
        this.saveloading= false;

        if (res.json().result != "") {
          this.toastr.success('', "The Devices has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.devicesid, data.devices);

          this.emitData.emit(this.devicesid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading= false;

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.devicesform.setValue({

      devicesid: deptBO.devicesid,
      devicestype: deptBO.devicestype,
      devicescode: deptBO.devicescode,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
